import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class RemoveStudentReveal extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.closeModal = this.closeModal.bind(this);
    this.unenrollClassroomHandler = this.unenrollClassroomHandler.bind(this);
  }

  static propTypes = {
    classroomActions: PropTypes.object,
    isAppOnline: PropTypes.any,
    classroom: PropTypes.any,
    student: PropTypes.object,
    idClassroom: PropTypes.string
  };

  unenrollClassroomHandler = async e => {
    e.preventDefault();
    const { isAppOnline } = this.props;
    if (isAppOnline) {
      const { classroomActions, classroom, student, idClassroom } = this.props;
      await classroomActions.unenrollStudent(student._id, classroom.id).then(() => {
        if (student.role === 'STUDENT') {
          classroomActions.setClassroomStudentsCount(idClassroom, -1);
        }
      });
      this.closeModal();
    }
  };

  closeModal() {
    let { classroomActions } = this.props;
    classroomActions.setUnenrollModalState(false);
  }

  render() {
    return (
      <Modal
        id="delete-user"
        title={I18n.t('studentList.removeStudent')}
        active
        onClickOutside={this.closeModal}
        children={
          <Paragraph className="text-grey-700">
            {I18n.t('studentList.removeStudentDisclaimer')} {I18n.t('common.uSure')}
          </Paragraph>
        }
        footer={
          <>
            <Button id="cancel-delete-user" onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button
              id="confirm-delete-user"
              onClick={this.unenrollClassroomHandler}
              primary
              label={I18n.t('common.delete')}
            ></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAppOnline: state.connection.status.online,
    classroom: state.classrooms.selectedClassroom.classroom,
    student: state.student.selectedStudent,
    i18n: state.i18n,
    idClassroom: state.router.params.idClassroom
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoveStudentReveal);
